import { render, staticRenderFns } from "./CarouselCaption.vue?vue&type=template&id=15ec8ed8&"
import script from "./CarouselCaption.vue?vue&type=script&lang=js&"
export * from "./CarouselCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports